import {createRoot, hydrateRoot} from 'react-dom/client';
import SitesGridArchitecture from '../pages/SitesGridArchitecture/SitesGridArchitecture'
import "../index.css";
import "../pages/SitesGridArchitecture/SitesGridArchitecture.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SitesGridArchitecture {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SitesGridArchitecture {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SitesGridArchitectureVC = {mount, hydrate, unmount}